// @flow
import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";

type UploadFormButtonPropsType = {
  classes: { [key: string]: string },
  cancelUpload: Function,
  formSubmitHandler: Function
};

class UploadFormButton extends Component<UploadFormButtonPropsType, *> {
  constructor(props: UploadFormButtonPropsType) {
    super(props);
  }

  handleSubmit = (e: Event ): * => {
    e.preventDefault();
    this.props.formSubmitHandler();
  }

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <form onSubmit={this.handleSubmit}>
        <Grid container spacing={24} className="top-margin-10">
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <Button color="primary" className={classes.linkBtn} onClick={this.props.cancelUpload}>Cancel</Button>
              <Button color="primary" variant="raised" type='submit' id="submitBtn" className={classes.primaryBtn} style={{ width: "60%", marginLeft: "5%" }}>Add to Your Faces</Button>
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default withStyles(buttonStyles)(UploadFormButton);


// WEBPACK FOOTER //
// ./src/conference/component/UploadFormButton.js